import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const NotFound404 = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language ?? 'en';

  useEffect(() => {
    window.location.replace(
      `https://www.swipesign.io/${lang !== 'en' ? `${lang}/` : ''}`
    );
  }, [lang]);

  return null;
};

export default NotFound404;
